<template>
    <div class="link-auto-table-filter-datepicker">
        <link-datepicker :start.sync="filterValue.startValue" :end.sync="filterValue.endValue" range :type="type" width="220px" @change="pl_change"/>
    </div>
</template>

<script>
    export default {
        name: "link-auto-table-filter-datepicker",
        props: {
            size: {type: String,},
            type: {type: String,},
            color: {type: String,},
            placeholder: {type: String, default: '搜索关键字...'},

            field: {},
            filterValue: {},
        },
        methods: {
            handleEnter() {
                this.$emit('confirm', {type: 'date', filtersRaw: this.getValue()});
            },
            getValue() {
                const ret = []
                !!this.filterValue.startValue && ret.push({id: this.field, property: this.field, operator: '>=', value: `${this.filterValue.startValue} 00:00:00`, type: 'date'})
                !!this.filterValue.endValue && ret.push({id: this.field, property: this.field, operator: '<=', value: `${this.filterValue.endValue} 23:59:59`, type: 'date'})
                return ret.length > 0 ? ret : null
            },
            pl_change() {
                this.handleEnter()
            },
        },
    }
</script>

<style lang="scss">
    .link-auto-table-filter-datepicker {
        display: flex;
        align-items: center;

        .link-auto-table-filter-datepicker-start {
            input {
                text-align: right;
            }
        }
    }
</style>
